<template>
  <el-container>
    <el-main style="padding: 0; width: 100vh">
      <span>出库单扫描</span>
      <el-divider/>
      <el-form ref="form" class="form" label-width="80px" @submit.native.prevent>
        <el-form-item label="出库单号">
          <el-input
              ref="billNoInput"
              v-model.trim="billNo"
              style="width: 300px"
              placeholder="请扫描出库单"
              @keyup.enter.native="scanHandle"/>
        </el-form-item>
      </el-form>
      <div>出库单明细</div>
      <el-divider/>
      <el-button
          type="primary"
          style="margin-bottom: 10px"
          :loading="loading"
          :disabled="!data.outStockBillDetailVOS.length"
          @click="postHandle">
        过账
      </el-button>
      <el-table stripe border :data="data.outStockBillDetailVOS" style="width: 100%">
        <el-table-column prop="materialNo" label="物料编号" width="140" show-overflow-tooltip/>
        <el-table-column prop="materialName" label="物料名称" min-width="300" show-overflow-tooltip/>
        <el-table-column prop="specification" label="物料规格" min-width="280" show-overflow-tooltip/>
        <el-table-column prop="unitName" label="单位" width="80" align="center"/>
        <el-table-column prop="actualQuantity" label="出库数量" width="140" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.actualQuantity" class="inputCenter" placeholder="请输入出库数量"/>
          </template>
        </el-table-column>
        <el-table-column prop="locationName" label="库位名称" width="180" show-overflow-tooltip/>
      </el-table>
    </el-main>
  </el-container>
</template>
<script>
  export default {
    name: "OutStoreScanIndex",
    data() {
      return {
        loading: false,
        billNo: "",
        data: {
          outStockBillDetailVOS: [],
        },
      };
    },

    mounted() {
      this.$refs.billNoInput.focus();
    },

    methods: {
      // 扫描出库单号
      scanHandle() {
        if (!this.billNo) {
          this.$confirm("出单单号不能为空", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.$http.get("basic", `scanRecords/scanOutStockBill/${this.billNo}`).then((resp) => {
          if (resp.success) {
            this.data = resp.data;
          }
        });
      },

      // 过账
      postHandle() {
        const result = this.data.outStockBillDetailVOS.some((item) => !item.actualQuantity);
        if (result) {
          this.$confirm("出库数量不能为空", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.loading = true;
          this.$http
            .post("basic", "outStockBills/outStockBillAction", this.data)
            .then((res) => {
              if (res.success) {
                this.$message.success("操作成功");
                this.billNo = "";
                this.data.outStockBillDetailVOS = [];
                this.loading = false;
              }else {
                this.loading = false;
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      },
    },
  };
</script>
